// src/pages/VerifyEmailRedirect.tsx

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useVerifyEmailMutation } from "../../../store/services/AuthService";
import { getErrorMessage } from "../../../utils/utils";
import { trackMetaEvent } from "../../utils/metaPixel";
import { pushDataLayerEvent } from "../../utils/gtm";

const VerifyEmailRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [verifyEmail] = useVerifyEmailMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    const verify = async () => {
      const searchParams = new URLSearchParams(location.search);
      const id = searchParams.get("id");
      const token = searchParams.get("token");
      console.log("token = ", token);

      if (id && token) {
        try {
          const response = await verifyEmail({ id, token }).unwrap();

          if (!response?.succeeded) {
            getErrorMessage(response?.errors?.[0]);
          } else {
            const metaEventId = response?.data?.metaEventId;
            if (metaEventId) {
              trackMetaEvent("CompleteRegistration", {}, metaEventId);
            }
            const googleEventId = response?.data?.googleEventId;
            pushDataLayerEvent("registration_complete", {
              google_event_id: googleEventId,
            });

            dispatch({
              type: "SIGN_IN",
              payload: {
                token: response.data.token,
                currentUser: response.data.data,
                role: response.data.data.role,
              },
            });
            navigate("/dashboard");
          }
        } catch (error) {
          getErrorMessage(error?.data?.errors?.[0]);
          console.error("Email verification error:", error);
        }
      }
    };

    verify();
  }, [location, verifyEmail, dispatch, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <h1>
        Please wait while we are verifying your email.......
      </h1>
    </div>
  );
};

export default VerifyEmailRedirect;